import { HeadlineWithSpacingProps } from 'ComponentLibrary/src/molecules/HeadlineWithSpacing/HeadlineWithSpacing'
import { styled } from '@mui/material'
import { EXTRA_SPACE_FOR_FLOATING_SAVE, MAX_MAIN_WIDTH } from './constants'
import { contentSpacing } from 'ComponentLibrary/src/styles/moduleSpacings'
import PageTemplate from './PageTemplate'
import { tokens } from 'ComponentLibrary'

export type PageTemplateWithSidebarProps = {
    children: React.ReactNode
    fullWidth?: boolean
    headline?: HeadlineWithSpacingProps
    withoutMaxWidth?: boolean
    withTopSpace?: boolean
    mainFullWidth?: boolean
}

export default function PageTemplateWithSidebar({
    children,
    fullWidth = false,
    mainFullWidth = false,
    headline,
    withoutMaxWidth,
    withTopSpace,
}: PageTemplateWithSidebarProps) {
    return (
        <StyledMain $withoutMaxWidth={withoutMaxWidth} $withTopSpace={withTopSpace} $mainFullWidth={mainFullWidth}>
            <PageTemplate fullWidth={fullWidth} headline={headline}>
                {children}
            </PageTemplate>
        </StyledMain>
    )
}

const StyledMain = styled('main', {
    shouldForwardProp: (prop: string) => prop[0] !== '$',
})<{ $withoutMaxWidth?: boolean; $withTopSpace?: boolean; $mainFullWidth?: boolean }>(
    ({ $withoutMaxWidth, $withTopSpace, $mainFullWidth }) => ({
        paddingBottom: `${contentSpacing + EXTRA_SPACE_FOR_FLOATING_SAVE}px`,
        paddingTop: $withTopSpace ? tokens.SizingSpacing400 : undefined,
        marginRight: `${contentSpacing}px`,
        maxWidth: $withoutMaxWidth ? undefined : $mainFullWidth ? '100%' : `${MAX_MAIN_WIDTH}px`,
    })
)
